import { useEffect, useRef } from 'react';
import { cn } from '@/lib/utils';
import { useAgentContainer } from '@/context/agent-container.context';

interface AgentContainerProps {
  className?: string;
}

export function AgentContainer({ className }: AgentContainerProps) {
  const ref = useRef<HTMLDivElement>(null);
  const { registerContainer, unregisterContainer } = useAgentContainer();

  useEffect(() => {
    if (ref.current) {
      registerContainer(ref.current);
    }
    return () => unregisterContainer();
  }, [registerContainer, unregisterContainer]);

  // relative z-50 creates a stacking context above the annotation canvas overlay (z-40),
  // so the chat panel stays fully interactive even when annotation mode is active.
  return (
    <div
      ref={ref}
      className={cn('relative z-50', className)}
      data-capture-exclude
    />
  );
}
